// Version : 0.0.1
// Author : Vignesh
// LastEdit : Vignesh
// Last ADD : Value name changed to small characters
// MODIFIED DATE: 18-08-2025

const CloseLoanActionTypes = {
	/** ***************** GET CLOSE LOAN LIST START *********************** */
	GET_CLOSE_LOAN_LIST_START: 'get_close_loan_start',
	GET_CLOSE_LOAN_LIST_SUCCESS: 'get_close_loan_success',
	GET_CLOSE_LOAN_LIST_FAILURE: 'get_close_loan_failure',
	GET_CLOSE_LOAN_LIST_RESPONSE_RESET: 'get_close_loan_response_reset',
	GET_CLOSE_LOAN_LIST_RESPONSE_CHANGED: 'get_close_loan_response_changed',
	/** ***************** GET CLOSE LOAN LIST END *********************** */

	/** ***************** UPDATE CLOSE LOAN START *********************** */
	UPDATE_CLOSE_LOAN_LIST_START: 'update_close_loan_start',
	UPDATE_CLOSE_LOAN_LIST_SUCCESS: 'update_close_loan_success',
	UPDATE_CLOSE_LOAN_LIST_FAILURE: 'update_close_loan_failure',
	UPDATE_CLOSE_LOAN_LIST_RESPONSE_RESET: 'update_close_loan_response_reset',
	UPDATE_CLOSE_LOAN_LIST_RESPONSE_CHANGED: 'update_close_loan_response_changed',
	/** ***************** UPDATE CLOSE LOAN END *********************** */

	/** ***************** REVERT CLOSE LOAN START *********************** */
	REVERT_CLOSE_LOAN_LIST_START: 'revert_close_loan_list_start',
	REVERT_CLOSE_LOAN_LIST_SUCCESS: 'revert_close_loan_list_success',
	REVERT_CLOSE_LOAN_LIST_FAILURE: 'revert_close_loan_list_failure',
	REVERT_CLOSE_LOAN_LIST_RESPONSE_RESET: 'revert_close_loan_list_response_reset',
	REVERT_CLOSE_LOAN_LIST_RESPONSE_CHANGED: 'revert_close_loan_list_response_changed',
	/** ***************** REVERT CLOSE LOAN END *********************** */
};
export default CloseLoanActionTypes;
